import { render } from "./SettingsTab.vue?vue&type=template&id=7fe57b3e&scoped=true"
import script from "./SettingsTab.vue?vue&type=script&lang=js"
export * from "./SettingsTab.vue?vue&type=script&lang=js"

import "./SettingsTab.vue?vue&type=style&index=0&id=7fe57b3e&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe57b3e"]])

export default __exports__